const items: string[] = [
  "LIVE 某头部主播被指虚假助农，带货佣金比例实锤曝光，一晚掉粉逾百万",
  "顶流歌手 顾言 被爆机场态度差＋团队压榨，人设崩塌现场监控画面流出",
  "童星转型女演员 苏念 被扒抄袭他人公益创意，口碑崩盘预警持续升级",
  "组合成员 池野 被拍到与经纪人行为越界，脱粉瞬间相关话题登上热搜",
  "导演 程墨 过往采访被考古，言论翻车遭网友逐条回放对线",
  "综艺常客 陆衍 被曝节目外言行两面，塌房档案再添新页",
  "选秀出身 白允 被指舞台假唱实锤，现场直击音频逐帧比对进行中",
];

function renderStrip(strip: string[], key: string) {
  return (
    <div className="flex shrink-0 items-center" aria-hidden={key === "2"}>
      {strip.map((t, i) => (
        <span key={`${key}-${i}`} className="flex items-center text-foreground-700">
          <span className="px-5 whitespace-nowrap text-[13px] md:text-sm">{t}</span>
          <i className="ri-flashlight-fill text-primary-500" aria-hidden="true"></i>
        </span>
      ))}
    </div>
  );
}

export default function BreakingTicker() {
  return (
    <div className="flex items-stretch border-b border-background-200/80 bg-background-100/70">
      <div className="relative z-10 flex shrink-0 items-center gap-2 border-r border-background-200 bg-accent-500 px-3.5 text-[13px] font-bold text-foreground-950 md:px-4">
        <span className="gk-pulse inline-block h-2 w-2 rounded-full bg-foreground-950"></span>
        现场快讯
      </div>
      <div className="relative flex-1 overflow-hidden">
        <div className="gk-marquee flex w-max items-center">
          {renderStrip(items, "1")}
          {renderStrip(items, "2")}
        </div>
      </div>
    </div>
  );
}